import React from "react";
import { Route, Routes } from "react-router-dom";
import InquiryList from "../../component/Inquiry/List";

function BannerPage() {
  return (
    <Routes>
      <Route path="/*" element={<InquiryList />} />
    </Routes>
  );
}

export default BannerPage;
